















import Vue from 'vue'
import LumberJackTableHeader from '@/UI/Tracking/LumberJack/LumberJackTableHeader.vue'
import LumberJackTableRow from '@/UI/Tracking/LumberJack/LumberJackTableRow.vue'

export default Vue.extend({
  name: 'LumberJackTable',
  components: {
    LumberJackTableRow,
    LumberJackTableHeader
  },
  props: {
    items: {
      type: Array,
      required: true
    }
  }
})
